
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import fails$1 from './fails.js';
import globalThis_1 from './global-this.js';

var fails = fails$1;
var globalThis = globalThis_1;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = globalThis.RegExp;

var regexpUnsupportedDotAll = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.test('\n') && re.flags === 's');
});

export { regexpUnsupportedDotAll as default };
//# sourceMappingURL=regexp-unsupported-dot-all.js.map
